import React from 'react';

import { ReactComponent as RubBtn } from '../../header/currency.picker/icons/rub.svg';
import { ReactComponent as CnyBtn } from '../../header/currency.picker/icons/cny.svg';
import { ReactComponent as UsdBtn } from '../../header/currency.picker/icons/usd.svg';
import { ReactComponent as EurBtn } from '../../header/currency.picker/icons/eur.svg';

import "./currency.picker.mobile.scss";
import cssIf from '../../../../scripts/helpers/class.add.if';
import useGlobal from '../../../../store';
import { CURRENCY } from '../../../../settings/constants';

const CurrencyPickerMobile = ({ opened, currency, changeCurrency, close }) => {

  function handleChoose( val ) {

    changeCurrency( val );
    close();

  }
  
  const content = [

    { id: CURRENCY.rub, icon: <RubBtn /> },
    { id: CURRENCY.cny, icon: <CnyBtn /> },
    { id: CURRENCY.usd, icon: <UsdBtn /> },
    { id: CURRENCY.eur, icon: <EurBtn /> },

  ]

  return (

    <div className = {`currency_picker_mobile ${ cssIf( opened, 'currency_picker_mobile--opened' ) }`}>

      { content.map(({ id, icon }, key ) => (

        id === currency ? null :

        <div

          key = { key }
          onClick = { () => handleChoose( id ) }
          className = {`currency_picker_mobile__option `}

        >
          { icon }          

        </div>

      ))}

    </div>

  );

}

export default CurrencyPickerMobile;